module.exports = __webpack_public_path__ + "static/media/icon-cross-green.f570e8f3.svg";